import { default as config } from "common/config/config";
import { formatTokenAmount } from "features/wallet/utils/tokenAmount";
import useTranslate from "ui/locale/hooks/useTranslate";
import usePointFindBy from "features/points/hooks/usePointFindBy";
import { useFormatBalance } from "ui/wallet/component/display/Balance/hook/useFormatBalance";

export interface UsePointsBalanceHintParams {
    lte?: string;
    isLoading?: boolean;
}

export default function usePointsBalanceHint({ lte, isLoading: isLoadingProp }: UsePointsBalanceHintParams) {
    const { data: { decimals } = {}, isLoading: isLoadingPointInfo } = usePointFindBy();

    const translate = useTranslate();
    const formattedMaxBalance = formatTokenAmount(lte || "0", decimals || 0);
    const formattedFiatBalance = useFormatBalance(formattedMaxBalance, {});

    const availableHint =
        lte && !isLoadingPointInfo ? translate("maxPoints", { points: formattedFiatBalance, units: config.tokenNames.points }) : undefined;
    const loadingHint = `${translate("loading")}...`;
    const isLoading = isLoadingPointInfo || isLoadingProp;
    const hint = isLoading ? loadingHint : availableHint;

    return {
        hint,
    };
}
